// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-container {
    height: calc(100vh - 6rem);
    overflow: auto;
    position: relative;
}

.analytics-tabs-wrapper {
    width: fit-content;
    white-space: nowrap;
    float: left;
    border-bottom: 1px solid rgb(161, 161, 161);
    min-height: 4rem;
    line-height: 4rem;
}

.analytics-tabs-wrapper span{
    margin-left: 1.6rem;
    margin-right: 1.6rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: medium;
    cursor: pointer;
    padding-bottom: 0.9rem;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    margin-top: auto;
}

.analytics-tabs-wrapper span.active{
    font-weight: bold;
    border-bottom: 2px solid #26a69a;
}

.analytics-header {
    display: flex;
    flex-direction: row;
    margin: 1.5rem 4rem;
    height: 4rem;
    line-height: 4rem;
}

.analytics-subtab-header {
    flex-direction: column;
}

.analytics-tabs__searching-input-container {
    width: 65%;
    margin-left: 6rem;
}`, "",{"version":3,"sources":["webpack://./src/app/analytics/analytics-main/analytics-tabs/AnalyticsTabs.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,2CAA2C;IAC3C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,yCAAyC;IACzC,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB","sourcesContent":[".analytics-container {\r\n    height: calc(100vh - 6rem);\r\n    overflow: auto;\r\n    position: relative;\r\n}\r\n\r\n.analytics-tabs-wrapper {\r\n    width: fit-content;\r\n    white-space: nowrap;\r\n    float: left;\r\n    border-bottom: 1px solid rgb(161, 161, 161);\r\n    min-height: 4rem;\r\n    line-height: 4rem;\r\n}\r\n\r\n.analytics-tabs-wrapper span{\r\n    margin-left: 1.6rem;\r\n    margin-right: 1.6rem;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    font-size: medium;\r\n    cursor: pointer;\r\n    padding-bottom: 0.9rem;\r\n    -moz-user-select: none;\r\n    -khtml-user-select: none;\r\n    user-select: none;\r\n    margin-top: auto;\r\n}\r\n\r\n.analytics-tabs-wrapper span.active{\r\n    font-weight: bold;\r\n    border-bottom: 2px solid #26a69a;\r\n}\r\n\r\n.analytics-header {\r\n    display: flex;\r\n    flex-direction: row;\r\n    margin: 1.5rem 4rem;\r\n    height: 4rem;\r\n    line-height: 4rem;\r\n}\r\n\r\n.analytics-subtab-header {\r\n    flex-direction: column;\r\n}\r\n\r\n.analytics-tabs__searching-input-container {\r\n    width: 65%;\r\n    margin-left: 6rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
